import { Icon } from '@tallink/components-lib'
import React from 'react'

import s from './PaymentIcons.module.scss'

export default function PaymentIcons() {
  return (
    <div className={s['payment-icons']}>
      <div className={s['payment-icons-row']}>
        <Icon size="original" type="paytrail-logo" />
        <Icon size="small" type="visa-logo" />
        <Icon size="xxxxl" type="mastercard-logo" />
        <Icon size="original" type="mobile-pay-logo" />
      </div>
      <div className={s['payment-icons-row']}>
        <Icon size="original" type="google-pay-logo" />
        <Icon size="original" type="apple-pay-logo" />
        <Icon size="original" type="klarna-logo" />
      </div>
    </div>
  )
}
